/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ "./src/js/formatMoney.js":
/*!*******************************!*\
  !*** ./src/js/formatMoney.js ***!
  \*******************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   formatMoney: () => (/* binding */ formatMoney)
/* harmony export */ });
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------

function formatMoney(cents, format) {
  if (typeof cents == 'string') {
    cents = cents.replace('.', '');
  }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || "${{amount}}";
  function defaultOption(opt, def) {
    return typeof opt == 'undefined' ? def : opt;
  }
  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal = defaultOption(decimal, '.');
    if (isNaN(number) || number == null) {
      return 0;
    }
    number = (number / 100.0).toFixed(precision);
    var parts = number.split('.'),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
      cents = parts[1] ? decimal + parts[1] : '';
    return dollars + cents;
  }
  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
    case "amount_with_apostrophe_separator":
      value = formatWithDelimiters(cents, 2, "'", ".");
      break;
  }
  return formatString.replace(placeholderRegex, value);
}
;

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry needs to be wrapped in an IIFE because it needs to be isolated against other modules in the chunk.
(() => {
/*!***************************!*\
  !*** ./src/js/product.js ***!
  \***************************/
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _formatMoney__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./formatMoney */ "./src/js/formatMoney.js");


/**
 * BG: This is a BIG function, that has alot of smaller functions. The whole purpose of this is to determine the variant options the user has selected, while highlighting the available and unavailable variants after each choice they make, and updating the price, and variant id field. This function works best when we have the first available variants selected.
 */
var productVariants = function productVariants() {
  var productVariants = document.querySelector("#product-variants");
  if (!productVariants) {
    return;
  }
  var radioBtns = productVariants.querySelectorAll('input[type="radio"]');
  var variantFieldsets = productVariants.querySelectorAll("fieldset");
  var masterVariantField = document.querySelector('.product-info form[action="/cart/add"] input[name="id"]');
  var cartBtn = document.querySelector('.product-info form[action="/cart/add"] button[type="submit"]');

  //get the variantData from the json markup.
  var getVariantData = function getVariantData() {
    return JSON.parse(productVariants.querySelector('[type="application/json"]').textContent);
  };

  //Debug
  //console.log(JSON.parse(productVariants.querySelector('[type="application/json"]').textContent));

  //BG: Triggered by the finalVariant function, we determine if the final variant Id selected is available or not, and update the button to reflect that choice.
  var addToBagBtn = function addToBagBtn(available) {
    if (available) {
      cartBtn.classList.remove("btn-disabled");
      cartBtn.classList.add("btn-primary");
      cartBtn.innerHTML = window.product.addToCart;
      cartBtn.disabled = false;
    } else {
      cartBtn.classList.add("btn-disabled");
      cartBtn.classList.remove("btn-primary");
      cartBtn.innerHTML = window.product.soldOut;
      cartBtn.disabled = true;
    }
  };

  //BG: the finalVariant funciton below will trigger this function, we essentially need the variant ID to query the price
  var variantPrice = function variantPrice(variantId) {
    var productPrice = document.querySelector(".js-product-price");
    var productCAP = document.querySelector(".js-product-compare-at-price");
    var variantData = getVariantData().filter(function (variant) {
      return variant.id === variantId;
    });

    //Update the product price, with the selected variant, and format the money.
    productPrice.innerHTML = (0,_formatMoney__WEBPACK_IMPORTED_MODULE_0__.formatMoney)(variantData[0].price, window.theme.moneyFormat);

    //Is there a Compare at price (CAP)? if so, let's update that too.
    if (variantData[0].compare_at_price != null) {
      //if CAP does exist, remove the hidden class if present.
      productCAP.classList.remove("hidden");
      //Update the CAP, with the selected variant, and format the money.
      productCAP.innerHTML = (0,_formatMoney__WEBPACK_IMPORTED_MODULE_0__.formatMoney)(variantData[0].compare_at_price, window.theme.moneyFormat);
    } else {
      //No CAP?, No Problem, let's just hide it.
      productCAP.classList.add("hidden");
    }
  };

  /**
   * BG: Once the user has selected all variant options, this function then triggers to update the variant ID field, price and url based on the users choice.
   */
  var finalVariant = function finalVariant(variant) {
    //BG: let's update the id input to the selected variant id
    masterVariantField.value = variant.id;
    //BG: Trigger the price update based on the variant ID
    variantPrice(variant.id);
    //BG: Update the add to bag btn based on the variant being available or not.
    addToBagBtn(variant.available);

    //Update the url with the user's variant choice.
    //Get the current URL without parameters
    var currentURLWithoutParams = window.location.href.split("?")[0];
    //update the page url with paramters
    history.pushState(null, null, currentURLWithoutParams + "?variant=" + variant.id);
  };

  /**
   * BG: There's a lot going on here, basically we determine how many variant options there are, and based on how many options there are, will determine the logic and approach. Essentially, we're determining what options are available or not available based on the user's choice.
   * checkedBtns(Array) - Checked radio buttons.
   */
  var remainingOptions = function remainingOptions(checkedBtns) {
    //If only one variant, remove all unavailable classes.
    if (variantFieldsets.length === 1) {
      productVariants.querySelectorAll(".js-unavailable-variant").forEach(function (label) {
        label.classList.remove("js-unavailable-variant");
      });
    }

    // for each checked radio button.
    checkedBtns.forEach(function (radio, index) {
      //First fieldset option
      if (index === 0) {
        //console.log('fire option 1');
        var remainingVariants;
        //if only one variant, then find all the unavailable variants
        if (variantFieldsets.length === 1) {
          remainingVariants = getVariantData().filter(function (variant) {
            return variant.available === false;
          });
        } else if (variantFieldsets.length === 2) {
          //if two variants, then find all the variants from option1 that match the selected radio option, and sort by unavailable first.
          remainingVariants = getVariantData().filter(function (variant) {
            return variant.option1 === checkedBtns[0].value;
          }).sort(function (variant) {
            return variant.available ? 1 : -1;
          });
        } else if (variantFieldsets.length > 2) {
          //if three variants, find all the variants from option1 and option2 that match the selected values for 1 & 2, and sort by unavailable first.
          remainingVariants = getVariantData().filter(function (variant) {
            return variant.option1 === checkedBtns[0].value && variant.option2 === checkedBtns[1].value;
          }).sort(function (variant) {
            return variant.available ? 1 : -1;
          });
        }
        //console.log(index);
        // console.log({ remainingVariants });
        remainingVariants.forEach(function (variant) {
          //if one variant, highlight the unavailable options.
          if (variantFieldsets.length === 1) {
            productVariants.querySelector(".js-variant-label[data-label-value=\"".concat(variant.option1, "\"]")).classList.add("js-unavailable-variant");
          }

          //if there is two variants, highlight the unavailable variants, and remove the class if the variant is available. During this array, we may come across the same item twice, therefore we sort by unavailable first to always ensure the available option is always highlighted at the end.
          if (variantFieldsets.length >= 2) {
            if (variant.available) {
              productVariants.querySelector(".js-variant-label[data-label-value=\"".concat(variant.option2, "\"]")).classList.remove("js-unavailable-variant");
            } else {
              productVariants.querySelector(".js-variant-label[data-label-value=\"".concat(variant.option2, "\"]")).classList.add("js-unavailable-variant");
            }
          }

          //if there is three variants, same as above.
          if (variantFieldsets.length > 2) {
            if (variant.available) {
              productVariants.querySelector(".js-variant-label[data-label-value=\"".concat(variant.option3, "\"]")).classList.remove("js-unavailable-variant");
            } else {
              productVariants.querySelector(".js-variant-label[data-label-value=\"".concat(variant.option3, "\"]")).classList.add("js-unavailable-variant");
            }
          }
        });
      }
      //Second Radio Option
      if (index === 1) {
        //console.log('fire option 2');
        var _remainingVariants;
        if (variantFieldsets.length === 2) {
          //if two variants, then find all the variants from option2 that match the selected radio option, and sort by unavailable first.
          _remainingVariants = getVariantData().filter(function (variant) {
            return variant.option2 === checkedBtns[1].value;
          }).sort(function (variant) {
            return variant.available ? 1 : -1;
          });
        } else if (variantFieldsets.length > 2) {
          //if three variants, find all the variants from option2 and option3 that match the selected values for 2 & 3, and sort by unavailable first.
          _remainingVariants = getVariantData().filter(function (variant) {
            return variant.option2 === checkedBtns[1].value && variant.option3 === checkedBtns[2].value;
          }).sort(function (variant) {
            return variant.available ? 1 : -1;
          });
        }
        //console.log(index);
        //console.log({remainingVariants});
        _remainingVariants.forEach(function (variant) {
          //if there is two variants, highlight the unavailable variants, and remove the class if the variant is available. During this array, we may come across the same item twice, therefore we sort by unavailable first to always ensure the available option is always highlighted at the end.
          if (variantFieldsets.length >= 2) {
            if (variant.available) {
              productVariants.querySelector(".js-variant-label[data-label-value=\"".concat(variant.option1, "\"]")).classList.remove("js-unavailable-variant");
            } else {
              productVariants.querySelector(".js-variant-label[data-label-value=\"".concat(variant.option1, "\"]")).classList.add("js-unavailable-variant");
            }
          }

          //if there is three variants, same as above.
          if (variantFieldsets.length > 2) {
            if (variant.available) {
              productVariants.querySelector(".js-variant-label[data-label-value=\"".concat(variant.option3, "\"]")).classList.remove("js-unavailable-variant");
            } else {
              productVariants.querySelector(".js-variant-label[data-label-value=\"".concat(variant.option3, "\"]")).classList.add("js-unavailable-variant");
            }
          }
        });
      }

      //Third Radio Option
      if (index === 2) {
        //console.log('fire option 3');
        //find all the variants from option3 and option1 that match the selected values for 3 & 1, and sort by unavailable first.
        var _remainingVariants2 = getVariantData().filter(function (variant) {
          return variant.option3 === checkedBtns[2].value && variant.option1 === checkedBtns[0].value;
        }).sort(function (variant) {
          return variant.available ? 1 : -1;
        });
        //console.log(index);
        //console.log({remainingVariants});
        _remainingVariants2.forEach(function (variant) {
          if (variant.available) {
            productVariants.querySelector(".js-variant-label[data-label-value=\"".concat(variant.option1, "\"]")).classList.remove("js-unavailable-variant");
          } else {
            productVariants.querySelector(".js-variant-label[data-label-value=\"".concat(variant.option1, "\"]")).classList.add("js-unavailable-variant");
          }
          if (variant.available) {
            productVariants.querySelector(".js-variant-label[data-label-value=\"".concat(variant.option2, "\"]")).classList.remove("js-unavailable-variant");
          } else {
            productVariants.querySelector(".js-variant-label[data-label-value=\"".concat(variant.option2, "\"]")).classList.add("js-unavailable-variant");
          }
        });
      }
    });
  };
  var productVariantSelects = document.querySelector("#product-variant-selects");
  var selects = productVariantSelects.querySelectorAll("select");
  var coatingSelect = selects[0];
  var tintSelect = selects[1];
  var tintSelectOptions = tintSelect.querySelectorAll("option");
  var coatingBtns = variantFieldsets[0].querySelectorAll('input[type="radio"]');
  var tintBtns = variantFieldsets[1].querySelectorAll('input[type="radio"]');
  coatingSelect.addEventListener("change", function (e) {
    coatingBtns[e.target.selectedIndex].click();
  });
  tintSelect.addEventListener("change", function (e) {
    tintBtns[e.target.selectedIndex].click();
    var tintSets = document.querySelectorAll(".js-tint-set");
    var tintRadios = document.querySelectorAll(".js-tint-set input");
    tintSets.forEach(function (tintSet) {
      tintSet.classList.add("hidden");
    });
    tintRadios.forEach(function (tint) {
      tint.checked = false;
      tint.addEventListener("click", function () {
        document.querySelector(".js-swatch-value").innerText = tint.value;
      });
    });
    if (tintSelect.value !== "No Tint") {
      document.querySelector(".js-swatch-picker").classList.remove("hidden");
      if (tintSelect.value === "Graduated Tint") {
        tintSets[1].classList.remove("hidden");
        tintSets[1].querySelector("input").checked = true;
        document.querySelector(".js-swatch-value").innerText = tintSets[1].querySelector("input").value;
      } else if (tintSelect.value === "Mirror Tint") {
        tintSets[2].classList.remove("hidden");
        tintSets[2].querySelector("input").checked = true;
        document.querySelector(".js-swatch-value").innerText = tintSets[2].querySelector("input").value;
      } else {
        tintSets[0].classList.remove("hidden");
        tintSets[0].querySelector("input").checked = true;
        document.querySelector(".js-swatch-value").innerText = tintSets[0].querySelector("input").value;
      }
    } else {
      document.querySelector(".js-swatch-picker").classList.add("hidden");
    }
  });
  coatingBtns.forEach(function (coating) {
    coating.addEventListener("change", function () {
      tintBtns.forEach(function (tint, i) {
        var availableTints = getVariantData().filter(function (variant) {
          return variant.title === "".concat(coating.value, " / ").concat(tint.value);
        });
        if (availableTints.length === 0) {
          tint.nextElementSibling.classList.add("opacity-20");
          tintSelectOptions[i].disabled = true;
        } else {
          tint.nextElementSibling.classList.remove("opacity-20");
          tintSelectOptions[i].disabled = false;
        }
      });
    });
  });

  //BG: For each radio button, attach an event listener that triggers when it's checked/unchecked.
  radioBtns.forEach(function (radio) {
    return radio.addEventListener("change", function () {
      //After a selection has been made, gather all checked options.
      var radioBtnsChecked = productVariants.querySelectorAll('input[type="radio"]:checked');

      //By default, we assume there will always be one radio button checked.
      var optionCombine = radioBtnsChecked[0].value;
      //console.log(radioBtnsChecked[0].value);

      //if there are two variant fields, we assume there will be two checked radio btns so add this to the variable.
      if (variantFieldsets.length >= 2) {
        //console.log(radioBtnsChecked[1].value);
        optionCombine += " / " + radioBtnsChecked[1].value;
      }
      //if there are three variant fields, we assume there will be three checked radio btns so add this to the variable.
      if (variantFieldsets.length > 2) {
        //console.log(radioBtnsChecked[2].value);
        optionCombine += " / " + radioBtnsChecked[2].value;
      }
      //console.log({optionCombine});
      //BG: with the combined result we search for the variant based on the variant.title.
      var combineVariant = getVariantData().filter(function (variant) {
        return variant.title === optionCombine;
      });
      if (!combineVariant[0]) {
        tintSelect.selectedIndex = 0;
        tintBtns[0].click();
      } else {
        finalVariant(combineVariant[0]);
        remainingOptions(radioBtnsChecked);
      }
    });
  });
  var currentRadioBtnsChecked = productVariants.querySelectorAll('input[type="radio"]:checked');
  remainingOptions(currentRadioBtnsChecked);
};
productVariants();
var productCarousel = function productCarousel() {
  var zoom = document.querySelector(".js-zoom-container");
  if (!!zoom) {
    setTimeout(function () {
      var slider = document.querySelector(".js-product-image-slider");
      var flkty = window.Flickity.data(slider);
      if (!!flkty) {
        var next = document.querySelector(".js-product-image-next");
        var prev = document.querySelector(".js-product-image-prev");
        var index = document.querySelector(".js-product-image-index");
        next.addEventListener("click", function () {
          flkty.next();
        });
        prev.addEventListener("click", function () {
          flkty.next();
        });
        flkty.on("change", function () {
          index.innerHTML = flkty.selectedIndex + 1;
          zoom.querySelector("div").innerHTML = slider.querySelector(".is-selected").innerHTML;
        });
      }
    }, 1000);
    if (window.matchMedia("(max-width: 1023px)").matches) {
      var image = zoom.querySelector("img");
      // Add a mousemove event listener to the outer_canvas
      zoom.addEventListener("mousemove", function (e) {
        // Calculate the relative position as a percentage
        var windowWidth = window.innerWidth;
        var windowHeight = window.innerHeight;
        var relativePosition = {
          left: (e.pageX - zoom.querySelector("div").getBoundingClientRect().left) / windowWidth * 100,
          top: (e.pageY - zoom.querySelector("div").getBoundingClientRect().top) / windowHeight * 100
        };
        // Calculate the maximum allowed translate values to prevent overscrolling past the image
        var maxTranslateX = windowWidth - image.width / 100 * relativePosition.left;
        var maxTranslateY = windowHeight - image.height / 100 * relativePosition.top - image.height / 2;

        // Adjust the transform values to prevent overscrolling past the image boundaries
        var translateX = -1 * Math.min(Math.max(maxTranslateX, 0), image.width - windowWidth);
        var translateY = -1 * Math.min(Math.max(maxTranslateY, 0), 0);

        // Apply the transform to the image

        image.style.transform = "translate(" + translateX + "px, " + translateY + "px)";
      });
    }
  }
};
productCarousel();
var prescriptionUpload = function prescriptionUpload() {
  var uploadRadios = document.querySelectorAll(".js-upload-radio");
  if (!!uploadRadios) {
    var uploadButton = document.querySelector(".js-upload-button");
    var fakeUpload = document.querySelector(".js-fake-upload");
    var realUpload = document.querySelector(".js-real-upload");
    var uploadFilename = document.querySelector(".js-upload-title");
    uploadRadios.forEach(function (radio) {
      radio.addEventListener("change", function () {
        if (radio.value === "now") {
          uploadButton.classList.remove("hidden");
          uploadFilename.classList.remove("hidden");
        } else {
          uploadButton.classList.add("hidden");
          uploadFilename.classList.add("hidden");
        }
      });
    });
    if (!!fakeUpload) {
      fakeUpload.addEventListener("click", function () {
        realUpload.click();
      });
    }
    if (!!realUpload) {
      realUpload.addEventListener("change", function () {
        uploadFilename.value = realUpload.value.replace(/.*[\/\\]/, "");
        uploadFilename.classList.remove("hidden");
      });
    }
  }
};
prescriptionUpload();
var pupilDistance = function pupilDistance() {
  var pdToggle = document.querySelector(".js-pd-toggle");
  if (!!pdToggle) {
    var pdInputs = document.querySelectorAll(".js-pd-input");
    pdToggle.addEventListener("change", function () {
      pdInputs.forEach(function (input) {
        input.classList.toggle("hidden");
        input.querySelectorAll("input").forEach(function (input) {
          input.value = "";
        });
      });
    });
  }
};
pupilDistance();
var stickyCart = function stickyCart() {
  var addBtn = document.querySelector(".js-add-to-cart");
  if (!!addBtn) {
    var stickyContatiner = document.querySelector(".js-sticky-container");
    var stickyBtn = stickyContatiner.querySelector('button');
    stickyBtn.addEventListener('click', function () {
      addBtn.click();
    });
    var options = {
      threshold: 1
    };
    var observer = new IntersectionObserver(function (entry) {
      if (entry[0].isIntersecting === false) {
        stickyContatiner.classList.remove("hidden");
      } else {
        stickyContatiner.classList.add("hidden");
      }
    }, options);
    observer.observe(addBtn);
  }
};
stickyCart();
})();

/******/ })()
;